var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternIllustrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF7F0",
    strokeWidth: 4,
    cx: 48,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#755CDE",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32h4v4h-4zM46 32h4v4h-4zM60 32h4v4h-4zM32 46h4v4h-4zM46 46h4v4h-4zM60 46h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 60h4v4h-4zM46 60h4v4h-4zM60 60h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#F39E9E",
    d: "m0 32 32 32V32z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 32h4v4h-4zM46 32h4v4h-4zM60 32h4v4h-4zM32 56h4v4h-4zM46 56h4v4h-4zM60 56h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 60h4v4h-4zM46 60h4v4h-4zM60 60h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#030303"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0h4v4h-4zM46 0h4v4h-4zM60 0h4v4h-4zM32 4h4v4h-4zM46 4h4v4h-4zM60 4h4v4h-4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 28h4v4h-4zM46 28h4v4h-4zM60 28h4v4h-4z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#61C4B7",
    d: "m0 32 32 32V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7F0",
    d: "M32 0 0 32V0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternIllustrations);
export default __webpack_public_path__ + "static/media/pattern-illustrations.14f5b1d2c7935111bba9043f4cf2051e.svg";
export { ForwardRef as ReactComponent };